import { Component, Element, h, Prop } from '@stencil/core';

@Component({
  tag: 'aafp-fieldset',
  shadow: false,
})
export class AafpFieldset {
  @Element() element: HTMLElement;
  @Prop() legend: string;
  @Prop() helperText: string;
  @Prop() errorMessage: string;
  @Prop() ariaLabel: string | null;
  @Prop() actionId: string;
  @Prop({ reflect: false }) disabled: boolean = false;

  @Prop() stateType: 'default' | 'error' | 'valid' = 'default';

  componentDidLoad() {}

  render() {
    const defaultErrorMessage = this.errorMessage || this.helperText;

    return (
      <div class={`adl-fieldset__container adl-fieldset__${this.stateType}`}>
        <div class={`adl-fieldset adl-fieldset__wrapper adl-background-color--lightest`}>
          <fieldset class="" disabled={this.disabled} id={this.actionId}>
            <legend>{this.legend}</legend>

            <slot name="content"></slot>
          </fieldset>
        </div>

        <i class="adl-fieldset__error-icon adl-fieldset__icon material-icons">error</i>
        <i class="adl-fieldset__icon adl-fieldset__valid-icon material-icons">done</i>
        <p class="adl-fieldset__helper-text adl-body-little">{this.helperText}</p>
        {defaultErrorMessage && <p class="adl-fieldset__error-text adl-body-little">{defaultErrorMessage}</p>}
      </div>
    );
  }
}
